import { render, staticRenderFns } from "./ModaFormComponent.vue?vue&type=template&id=6061d1dc&scoped=true"
import script from "./ModaFormComponent.vue?vue&type=script&lang=js"
export * from "./ModaFormComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModaFormComponent.vue?vue&type=style&index=1&id=6061d1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061d1dc",
  null
  
)

export default component.exports